import { Component, OnInit } from '@angular/core';
import { InjectLogger } from '../decorators';
import { Logger } from '../utils/logger';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
  @InjectLogger() static logger: Logger;

  async ngOnInit() {
    PagesComponent.logger.debug('ngOnInit()');
  }
}
